export default {
  set(state, { token, authenticated }) {
    state.authenticated = authenticated;
    state.token = token;
  },
  profile(state, {admin, smartmach, maintainer, vm, company, parent_company}) {
    state.admin = admin
    state.smartmach = smartmach
    state.maintainer = maintainer
    state.vm = vm
    state.company = company
    state.parent_company = parent_company
  }
}